import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import styles from './license-details.css';
export function LicenseDetailItem({ title, value, ...rest }) {
    return (_jsxs("div", { className: styles.licenseContainer, ...assignTestId('license-detail-item', rest), children: [_jsxs(Text, { size: "s", info: true, className: styles.title, children: [title, ":"] }), _jsx(Text, { children: value })] }));
}
